<template>
    <div class="custom-filter">
        <div class="custom-filter__inputs align-start">
            <div class="custom-filter__inputs--label">
                Date

                <div class="label currency-datepicker">
                    <div class="label__input-wrap">
                        <datepicker placeholder="De"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.start_date"
                                    :highlighted="filters.start_date ? '' : highlightedConfig">
                        </datepicker>
                        <datepicker placeholder="à"
                                    format="DD/MM/YYYY"
                                    :monday-first="true"
                                    :full-month-name="true"
                                    wrapper-class="currency-datepicker__wrapper-low-margin"
                                    input-class="currency-datepicker__input"
                                    calendar-class="currency-datepicker__element"
                                    v-model="filters.end_date"
                                    :highlighted="filters.end_date ? '' : highlightedConfig">
                        </datepicker>
                    </div>
                </div>
            </div>
            <label class="custom-filter__inputs--label">
                Nom
                <input class="custom-filter__inputs--field" v-model="filters.full_name">
            </label>
<!--          #3228 - Quote page - Garanties dropdown menu to remove-->
<!--            <label class="custom-filter__inputs&#45;&#45;label">-->
<!--                Garanties-->
<!--&lt;!&ndash;                <input class="custom-filter__inputs&#45;&#45;field" v-model="filters.price"&ndash;&gt;-->
<!--&lt;!&ndash;                       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">&ndash;&gt;-->
<!--                <select name="category" id="category" v-model="filters.category">-->
<!--                    <option value="">Tout</option>-->
<!--                    <option value="1">Camping Car</option>-->
<!--                    <option value="2">Auto</option>-->
<!--                    <option value="3">Moto</option>-->
<!--                </select>-->
<!--            </label>-->
        </div>
        <div class="custom-filter__buttons">
            <button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button>
        </div>
    </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'DevisCustomFilter',
        components: {Datepicker},
        data() {
            return {
                highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        props: {
            filters: Object
        },
        methods: {
            emitFilters() {
                this.$eventBus.$emit('get-devis');
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Devis/DevisCustomFilter.vue